import { Theme } from "../core/Theme";

/**
 * @ignore
 */
export class KxyTheme extends Theme {
	protected setupDefaultRules() {
		super.setupDefaultRules();
        this.rule("ColorSet").setAll({
            startIndex: 0
        });
		this.rule("AxisRenderer").setAll({
            minGridDistance: 30
        });
        this.rule("AxisLabel").setAll({
            fontSize: "1em"
        });
        this.rule("Graphics", ["line", "series", "stroke"]).setAll({
            strokeWidth: 2
        });
    }
}